var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-dark"},[(_vm.loggedIn)?_c('span',{staticClass:"text-danger"},[_vm._v(" Giriş Yapıldı ")]):_c('span',[_vm._v("Giriş Yapılmadı")]),_c('div',[_c('button',{staticClass:"btn btn-warning mt-1",on:{"click":_vm.signOut}},[_vm._v("Sign Out")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }